module.exports = "/img/not-found.png?77aab88e18c2a8d8b2e3c54c2e69e901";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/not-found.png
// module id = EtaB
// module chunks = 70